import { renderPageClient } from './renderPageClient';
renderPageClient();
